import React, { useState } from 'react'
import { Col, Container, Form, FormGroup, Spinner } from 'reactstrap';
import CustomInput from './CustomInput';
import { Mail } from 'assets';
import { FiArrowLeft } from 'react-icons/fi';
import CustomButton from 'components/CustomButton';
import { useNavigate } from 'react-router-dom';
import { API_POST_MAMBOO } from 'services';

const LupaPassword = () => {
  const [email, setEmail] = useState("")
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleBack = () => {
    navigate("/auth/login")
  }

  const onChange = (e) => {
    const { name, value } = e.target
    setEmail(value)
    if (value === "a@a.a") setError('Email belum terdaftar, masukan email yang sudah terdaftar di mamboo sebelumnya')
    else setError("")

  }

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true)

    API_POST_MAMBOO.actions.forgotPassword({email}).then((resp) => {
      setIsLoading(false)
    }).catch((err) => {
      console.log('err', err)
    })
  }

  return (
    <Container>
      <div className="text-wrapper">
        <FiArrowLeft className="arrow-left" onClick={handleBack} />
        <h3>Lupa Password ?</h3>
        <h6>
          Masukan email anda yang terdaftar di mamboo, kami akan mengirimkan
          Link verifikasi ke email tersebut.
        </h6>
      </div>
      <Col>
        <Form className="auth-form" onSubmit={handleSubmit}>
          <FormGroup className="custom-form-group">
            <CustomInput
              label="Email"
              name="email"
              placeholder="Email address"
              Icon={Mail}
              onChange={onChange}
              value={email}
              error={error}
              iconPosition="left"
            />
          </FormGroup>
          <CustomButton
            label={
              isLoading ? (
                <>
                  <Spinner size="sm" color="light" />
                </>
              ) : (
                "Kirim Link Verifikasi"
              )
            }
            color="primary-btn"
            disabled={isLoading}
          />
        </Form>
      </Col>
    </Container>
  );
}

export default LupaPassword